module.exports = __webpack_public_path__ + "media/images/map-marker-dark-f3df8230e35744b9e38b047540187d91.png";